import { Progress } from '@mantine/core';
import classnames from 'classnames';
import { useEffect, useRef } from 'react';
import { useAutoProgressFade, useHoverPause } from './AiExplanation.hooks';
import { ScrollText, Wrapper } from './AiExplanation.style';

export type AiExplanationProps = {
  text: string;
  callbacks: {
    clear: () => void;
  };
};

export function AiExplanation({ text, callbacks }: AiExplanationProps) {
  const ref = useRef<HTMLDivElement>(null);
  const refContent = useRef<HTMLDivElement>(null);
  const isPaused = useHoverPause(ref);
  const { progress, visible, displayText } = useAutoProgressFade(text, isPaused, callbacks.clear);

  const className = classnames('AiExplanation-wrapper', {
    visible,
  });

  useEffect(() => {
    if (!visible || !refContent.current) return;
    refContent.current.scrollTop = 0;
  }, [visible]);

  return (
    <Wrapper ref={ref} className={className} data-testid='AiExplanation-wrapper'>
      <Progress value={progress} radius='xl' size='sm' color='pink' />
      <ScrollText ref={refContent}>{displayText}</ScrollText>
    </Wrapper>
  );
}

export default AiExplanation;
